const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECT"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.5,
      fill: "#F5F5F5"
    },
    cx: 250.393,
    cy: 433.504,
    rx: 221.318,
    ry: 30.693
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M210.572,378.395c0.043-3.152-0.082-7.52-0.834-12.65c-0.634-4.321-2.658-18.124-9.936-28.555 c-11-15.765-23.47-8.736-36.252-25.035c-7.315-9.328-5.258-14.216-13.624-21.683c-7.39-6.596-15.323-9.025-23.776-10.415 c-21.39-3.518-56.287-0.218-56.287-0.218c2.946,33.824,14.316,47.809,24.128,54.335c13.77,9.158,24.362,3.548,36.635,14.51 c15.977,14.27,5.489,30.439,20.39,45.286c0,0,6.523,6.5,57.146,16.121l0,0L210.572,378.395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#D6D6D6",
      strokeWidth: 0.4657,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M208.162,410.091c0,0-39.107-66.558-54.004-79.602c-14.897-13.044-84.295-50.65-84.295-50.65"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D6D6D6",
      strokeWidth: 0.4657,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 120.082,
    y1: 308.223,
    x2: 76.399,
    y2: 310.668
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D6D6D6",
      strokeWidth: 0.4657,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 129.106,
    y1: 313.629,
    x2: 132.005,
    y2: 281.233
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D6D6D6",
      strokeWidth: 0.4657,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 148.968,
    y1: 326.464,
    x2: 111.16,
    y2: 340.433
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D6D6D6",
      strokeWidth: 0.4657,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 164.964,
    y1: 343.067,
    x2: 169.829,
    y2: 318.506
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D6D6D6",
      strokeWidth: 0.4657,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 177.165,
    y1: 360.469,
    x2: 140.539,
    y2: 367.159
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D6D6D6",
      strokeWidth: 0.4657,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 186.719,
    y1: 375.139,
    x2: 200.503,
    y2: 338.231
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D6D6D6",
      strokeWidth: 0.4657,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 195.413,
    y1: 389.008,
    x2: 153.049,
    y2: 395.253
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M187.32,383.607c-1.165-2.929-2.95-6.918-5.606-11.371c-2.237-3.751-9.383-15.732-20.096-22.589 c-16.191-10.364-25.027,0.898-43.068-9.279c-10.325-5.824-10.292-11.127-20.877-14.83c-9.35-3.271-17.61-2.483-25.951-0.537 c-21.111,4.924-52.097,21.311-52.097,21.311c15.65,30.13,31.502,38.708,43.063,40.988c16.225,3.199,23.869-6.032,39.4-0.593 c20.218,7.08,16.706,26.03,36.15,34.055c0,0,8.512,3.513,58.969-6.945l0,0L187.32,383.607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#D6D6D6",
      strokeWidth: 0.4657,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M197.207,413.817c0,0-61.577-46.558-80.328-52.918c-18.752-6.361-97.254-14.587-97.254-14.587"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D6D6D6",
      strokeWidth: 0.4657,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 76.88,
    y1: 353.348,
    x2: 37.447,
    y2: 372.303
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D6D6D6",
      strokeWidth: 0.4657,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 87.285,
    y1: 354.895,
    x2: 77.582,
    y2: 323.85
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D6D6D6",
      strokeWidth: 0.4657,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 110.545,
    y1: 359.164,
    x2: 80.946,
    y2: 386.523
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D6D6D6",
      strokeWidth: 0.4657,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 131.672,
    y1: 368.393,
    x2: 126.78,
    y2: 343.837
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D6D6D6",
      strokeWidth: 0.4657,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 149.598,
    y1: 379.811,
    x2: 118.309,
    y2: 399.991
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D6D6D6",
      strokeWidth: 0.4657,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 164.033,
    y1: 389.715,
    x2: 162.664,
    y2: 350.341
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D6D6D6",
      strokeWidth: 0.4657,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 177.368,
    y1: 399.208,
    x2: 140.607,
    y2: 421.171
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF92C9"
    },
    points: "329.8,414.324 196.463,414.324 209.304,326.153 316.959,326.153  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDB6D6"
    },
    d: "M428.915,341.698H97.348c-8.424,0-15.253-6.829-15.253-15.253V117.563 c0-8.424,6.829-15.253,15.253-15.253h331.567c8.424,0,15.253,6.829,15.253,15.253v208.882 C444.168,334.869,437.339,341.698,428.915,341.698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDEEF"
    },
    d: "M420.129,316.583H106.134c-8.424,0-15.253-6.829-15.253-15.253V124.77 c0-8.424,6.829-15.253,15.253-15.253h313.996c8.424,0,15.253,6.829,15.253,15.253v176.56 C435.383,309.754,428.554,316.583,420.129,316.583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDB6D6"
    },
    d: "M358.061,420.744h-189.86v-9.172c0-7.092,5.749-12.841,12.841-12.841h164.178 c7.092,0,12.841,5.749,12.841,12.841V420.744z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 102.113,
    y1: 316.583,
    x2: 417.782,
    y2: 316.583
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M176.559,416.158 v-4.815c0-2.913,2.361-5.274,5.274-5.274h142.395"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 309.094,
    y1: 348.744,
    x2: 314.138,
    y2: 387.267
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 259.947,
    cy: 329.92,
    r: 7.387
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M365.043,123.572 h39.21c7.472,0,13.529,6.057,13.529,13.529v81.471"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3897E9"
    },
    d: "M394.966,149.38c2.265-5.448,4.504-9.663,6.718-12.642c2.213-2.979,5.095-5.355,8.649-7.127 c2.077-1.086,4.24-1.865,6.496-2.336c2.252-0.47,4.396-1.069,6.432-1.794c2.032-0.724,3.903-1.708,5.611-2.948 c1.707-1.24,3.117-3.198,4.231-5.877c1.88-4.524,1.949-8.207,0.204-11.044c-1.745-2.837-4.327-4.967-7.743-6.387 c-4.897-2.035-8.834-2.073-11.812-0.117c-2.981,1.957-5.662,5.148-8.042,9.574l-17.87-7.428c1.881-4.524,4.327-8.328,7.341-11.408 c3.012-3.079,6.419-5.346,10.219-6.8c3.798-1.452,7.902-2.076,12.312-1.868c4.406,0.207,8.92,1.271,13.539,3.191 c9.974,4.146,17.001,9.451,21.086,15.914c4.081,6.464,4.224,14.266,0.423,23.409c-1.229,2.957-2.605,5.416-4.125,7.384 c-1.523,1.966-3.259,3.6-5.207,4.903c-1.95,1.301-4.129,2.373-6.535,3.214c-2.409,0.841-5.065,1.631-7.972,2.372 c-2.686,0.726-4.929,1.5-6.732,2.319c-1.804,0.822-3.338,1.837-4.596,3.045c-1.262,1.209-2.321,2.585-3.176,4.122 c-0.858,1.54-1.708,3.327-2.551,5.357L394.966,149.38z M383.298,175.887l7.544-18.148l18.701,7.774l-7.544,18.148L383.298,175.887 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M285.994,176.616v-14.82c0-4.861-3.941-8.802-8.802-8.802h-86.028c-4.861,0-8.802,3.941-8.802,8.802 v14.82v98.732c0,4.861,3.941,8.802,8.802,8.802h137.567c4.861,0,8.802-3.941,8.802-8.802v-89.93c0-4.861-3.941-8.802-8.802-8.802 H285.994z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6D6D6"
    },
    points: "277.279,197.316 259.947,214.648 242.616,197.317 232.157,207.775 249.488,225.107  232.157,242.439 242.616,252.897 259.947,235.566 277.279,252.897 287.738,242.439 270.406,225.107 287.738,207.775  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7A99C"
    },
    points: "72.157,419.889 72.157,408.478 51.143,408.478 51.143,439.857 98.591,440.618  98.591,434.913  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC001"
    },
    d: "M100.271,440.618v-2.705c0-2.766-1.517-5.308-3.951-6.622l-20.011-10.8 c-5.999,1.639-10.635,1.409-13.803,0.872c-5.261-0.893-10.289-3.283-11.981-1.284c-0.484,0.572-0.542,1.322-0.523,1.838v16.593 c0,1.164,0.944,2.108,2.108,2.108H100.271z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#3897E9",
      strokeWidth: 0.733,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 100.271,
    y1: 438.811,
    x2: 50.001,
    y2: 438.811
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#3897E9",
      strokeWidth: 0.733,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 89.195,
    y1: 427.673,
    x2: 86.379,
    y2: 431.395
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#3897E9",
      strokeWidth: 0.733,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 87.132,
    y1: 426.508,
    x2: 84.316,
    y2: 430.23
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#3897E9",
      strokeWidth: 0.733,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 84.977,
    y1: 425.429,
    x2: 82.16,
    y2: 429.15
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#3897E9",
      strokeWidth: 0.733,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M81.803,423.456c-3.41,1.301-9.038,2.969-16.143,2.931c-6.855-0.037-12.296-1.648-15.658-2.931"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7A99C"
    },
    points: "132.062,419.889 132.062,408.478 111.048,408.478 111.048,439.857 158.496,440.618  158.496,434.913  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC001"
    },
    d: "M160.176,440.618v-2.705c0-2.766-1.517-5.308-3.951-6.622l-20.011-10.8 c-5.999,1.639-10.635,1.409-13.803,0.872c-5.261-0.893-10.289-3.283-11.981-1.284c-0.484,0.572-0.542,1.322-0.523,1.838v16.593 c0,1.164,0.944,2.108,2.108,2.108H160.176z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#3897E9",
      strokeWidth: 0.733,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 160.176,
    y1: 438.811,
    x2: 109.907,
    y2: 438.811
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#3897E9",
      strokeWidth: 0.733,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 149.1,
    y1: 427.673,
    x2: 146.284,
    y2: 431.395
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#3897E9",
      strokeWidth: 0.733,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 147.037,
    y1: 426.508,
    x2: 144.221,
    y2: 430.23
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#3897E9",
      strokeWidth: 0.733,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 144.882,
    y1: 425.429,
    x2: 142.066,
    y2: 429.15
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#3897E9",
      strokeWidth: 0.733,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M141.708,423.456c-3.41,1.301-9.038,2.969-16.143,2.931c-6.854-0.037-12.296-1.648-15.658-2.931"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3897E9"
    },
    d: "M119.986,257.384c0,0,17.306,54.961,19.968,62.568c2.662,7.607,5.135,18.257,4.564,27.575 c-0.571,9.319-9.509,66.751-9.509,66.751h-26.054c0,0-1.84-60.666-2.727-65.42c-0.887-4.754-8.494-31.647-8.494-31.647 s-2.472,31.457-4.564,39.824c-2.092,8.368-18.827,58.194-18.827,58.194H50.001l10.27-157.845H119.986z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A99C"
    },
    d: "M159.705,223.88c0,0,8.263-7.01,10.354-11.596c1.79-3.925,4.292-10.821,4.976-12.727 c0.103-0.288,0.405-0.447,0.702-0.377l0.495,0.117c1.533,0.363,2.48,1.903,2.112,3.435l-0.825,3.438l8.731-5.734 c0.749-0.492,1.758-0.25,2.202,0.529c0.392,0.687,0.205,1.559-0.434,2.024l-5.759,4.2l9.567-4.492 c0.741-0.348,1.624-0.068,2.03,0.643l0.012,0.021c0.429,0.753,0.167,1.711-0.586,2.14l0.107-0.031 c0.831-0.239,1.712,0.164,2.074,0.948c0.42,0.908-0.006,1.982-0.933,2.357l-0.609,0.246c0.794-0.248,1.628,0.247,1.79,1.063h0 c0.237,1.191-0.337,2.394-1.414,2.955c-2.575,1.34-4.246,1.693-6.693,3.525c-1.937,1.449-1.259,2.372-3.325,5.015 c-2.516,3.219-4.659,3.31-8.993,6.496c-1.646,1.21-3.919,3.096-6.321,5.903L159.705,223.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 0.4147,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M188.591,201.31c0,0,0.439,0.89-0.395,1.524c-0.833,0.634-7.339,5.45-7.339,5.45"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 0.4147,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 193.282,
    y1: 205.501,
    x2: 184.324,
    y2: 209.659
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 0.4147,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 194.204,
    y1: 208.967,
    x2: 185.198,
    y2: 213.112
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 0.4147,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M176.858,199.529c0,0,1.574,0.996,1.53,2.1c-0.044,1.104-1.632,8.196-1.632,8.196"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1775AF"
    },
    d: "M108.956,414.279c0,0-2.358-62.204-2.542-63.812c-0.184-1.608-9.049-34.532-9.049-34.532 l1.57-14.552c0,0,17.885,44.026,17.885,46.93c0,2.905,1.987,65.966,1.987,65.966H108.956z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 0.4147,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 94.186,
    y1: 353.228,
    x2: 100.542,
    y2: 284.485
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#262626"
    },
    points: "136.011,409.001 108.755,409.001 108.956,414.279 135.01,414.279  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#262626"
    },
    points: "75.923,410.515 50.308,410.515 50.001,415.23 74.344,415.23  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.4147,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M137.597,325.387c3.449,10.857,3.996,22.621,1.568,33.751"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4450E4"
    },
    d: "M166.574,216.488c0,0-4.412,3.397-9.438,4.279c-5.889,1.034-10.996-2.454-12.367-3.39 c-3.734-2.55-5.113-5.571-7.582-9.106c-7.314-10.47-11.857-16.974-18.217-20.657c-3.287-1.904-8.784-4.053-17.45-3.388 c-1.944-0.697-5.043-0.145-7.119-0.145c-1.726,0-3.451,0-5.177,0c-3.402,0.408-28.458,3.319-32.718-0.593 c-1.679-1.542-1.706-3.061-1.706-3.061c-0.022-1.256,0.771-2.563,2.847-4.144c5.073-3.863,14.379-6.747,17.496-7.666 l-1.902-14.204c0,0,0,0-4.184,0s-19.018,2.472-27.005,5.263c-11.199,3.913-17.199,6.769-20.159,13.256 c-3.708,8.129,0.242,16.866,1.268,19.136c5.142,11.373,16.544,15.976,23.431,18.756c6.074,2.452,11.48,3.437,15.238,3.875 l-3.233,51.728l59.456,3.233h8.929c0.684-7.904-2.736-32.462-2.293-40.484c7.591,10.564,20.165,15.899,32.102,13.605 c13.215-2.539,19.861-13.315,20.943-15.134C173.122,218.548,166.574,216.488,166.574,216.488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M92.703,212.741H92.13v-24.688h3.745v21.516C95.875,211.321,94.455,212.741,92.703,212.741z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3748C4"
    },
    d: "M127.073,266.932c-2.048,0.38-30.191,5.099-50.077-15.898 C60.216,233.317,62.2,210.896,62.55,207.58c-1.044,15.552-2.089,31.104-3.133,46.656H59.36l-0.762,12.19l9.32,0.507l-0.006-0.066 c13.9,1.1,28.245,1.921,43.014,2.405c5.41,0.177,10.763,0.305,16.058,0.388C127.013,268.75,127.043,267.841,127.073,266.932z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626"
    },
    d: "M111.307,165.393c1.019-5.23,0.86-9.318,0.564-11.931c-0.225-1.988-0.571-3.493-1.627-4.924 c-0.223-0.302-1.977-2.608-4.987-3.21c-3.6-0.721-4.509,1.894-9.63,2.528c-4.416,0.546-5.286-1.207-8.256,0.052 c-3.244,1.375-4.845,4.586-5.331,5.561c-0.212,0.426-1.269,2.604-1.376,5.656c-0.085,2.417,0.467,4.235,0.686,4.979 c0.92,3.131,2.003,7.893,3.327,15.506c0.691-0.026,1.383-0.051,2.074-0.077C94.937,174.818,103.122,170.105,111.307,165.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A99C"
    },
    d: "M93.798,191.115L93.798,191.115c-3.868,0.015-7.015-3.109-7.029-6.976l-0.057-15.07l14.006-0.053 l0.057,15.07C100.789,187.953,97.666,191.1,93.798,191.115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7769"
    },
    d: "M100.758,179.867l-9.121-4.686c0.092,0.79,0.611,4.489,3.864,7.044 c2.077,1.631,4.261,2.004,5.269,2.11L100.758,179.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A99C"
    },
    d: "M86.372,164.4c-0.044-0.228-0.644-0.572-0.828-0.689c-0.311-0.199-0.648-0.358-1-0.471 c-0.683-0.22-1.434-0.271-2.136-0.11c-1.396,0.32-2.634,1.493-2.867,2.93c-0.135,0.835,0.058,1.698,0.415,2.464 c0.538,1.152,1.45,2.12,2.552,2.754c0.913,0.526,1.952,0.824,3.002,0.886c0.21,0.012,2.363-0.037,2.347-0.12 C87.361,169.496,86.866,166.948,86.372,164.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A99C"
    },
    d: "M84.452,164.546c0.166,1.124,1.154,7.055,6.5,11.245c0.985,0.772,7.531,5.903,13.521,3.399 c7.697-3.218,6.857-15.86,6.803-16.545c-0.183-2.315-0.724-9.132-6.369-12.769c-4.607-2.968-9.6-1.877-10.308-1.71 c-0.746,0.175-5.499,1.375-8.408,6.035C83.55,158.43,84.181,162.706,84.452,164.546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626"
    },
    d: "M106.907,162.654c0.124,0.987,0.885,1.704,1.7,1.602c0.815-0.102,1.375-0.985,1.251-1.972 c-0.124-0.987-0.885-1.704-1.7-1.602C107.343,160.784,106.783,161.667,106.907,162.654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626"
    },
    d: "M98.013,163.771c0.124,0.987,0.885,1.704,1.7,1.602c0.815-0.102,1.375-0.985,1.251-1.972 c-0.124-0.987-0.885-1.704-1.7-1.602C98.45,161.901,97.889,162.784,98.013,163.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 0.733,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M104.222,164.131l1.363,1.842c0.251,0.338,0.157,0.819-0.203,1.038l-1.252,0.762"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7769"
    },
    d: "M95.03,168.42c0.139,1.107,1.15,1.893,2.257,1.753c1.107-0.139,1.893-1.15,1.753-2.257 c-0.139-1.107-1.15-1.893-2.257-1.753C95.676,166.302,94.891,167.313,95.03,168.42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 0.733,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M85.432,169.464c0.007-0.222,0.025-1.726-1.181-2.811c-0.945-0.85-2.045-0.906-2.345-0.911"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 0.733,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M84.368,166.951c-0.067-0.011-0.876-0.123-1.441,0.489c-0.465,0.503-0.422,1.125-0.413,1.228"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626"
    },
    d: "M84.275,163.165c0,0,0.995,0.088,1.745,0.833c0.75,0.744,1.016,2.019,1.016,2.019 c1.917-0.233,6.308-1.042,10.291-4.499c2.159-1.874,3.477-3.9,4.254-5.361c0.726,0.653,1.965,1.634,3.718,2.39 c2.287,0.986,5.144,1.458,5.523,0.69c0.07-0.142-0.007-0.554-0.163-1.377c-0.056-0.298-0.115-0.739-0.26-1.161 c-0.283-0.826-0.651-1.623-1.09-2.378c-0.88-1.51-2.051-2.851-3.429-3.926c-0.896-0.698-1.879-1.284-2.925-1.729 c-3.32-1.412-7.93-1.413-11.898,0.703c0,0-4.43,2.363-6.383,6.987c-0.671,1.589-0.84,3.178-0.882,3.729 c-0.084,1.091,0.039,1.804,0.205,2.352C84.091,162.747,84.196,162.996,84.275,163.165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7769"
    },
    d: "M110.227,165.224c0.383-0.048,0.752,0.02,1.08,0.169c-0.039,1.085-0.143,2.401-0.382,3.797 c-0.065,0.015-0.127,0.036-0.194,0.045c-1.107,0.139-2.118-0.646-2.257-1.753S109.119,165.363,110.227,165.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M95.397,148.423c-0.658-0.256-1.622-0.605-2.809-0.946c-2.602-0.746-3.903-1.119-5.087-0.967 c-3.466,0.445-5.457,5.013-6.292,6.929c-0.632,1.45-1.666,3.911-1.118,6.994c0.244,1.372,0.727,2.445,1.111,3.154"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M95.397,148.011c1.172-0.512,2.425-0.927,3.554-1.514c1.185-0.616,2.22-1.417,3.489-1.89c1.333-0.497,2.821-0.696,4.182-0.283 c1.173,0.356,2.176,1.14,3.004,2.044c1.115,1.218,1.964,2.688,2.406,4.279c0.852,3.066,0.091,6.261-0.411,9.317"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M105.726,171.992c0,0.996-0.97,1.803-2.166,1.803c-1.197,0-2.167-0.807-2.167-1.803 s0.97-1.803,2.167-1.803C104.756,170.19,105.726,170.997,105.726,171.992z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A99C"
    },
    d: "M73.568,156.85l4.001-2.437c0,0,0.817-3.525,1.928-4.27c1.111-0.745,7.015-3.038,7.015-3.038 l0.86,0.803c0,0-4.62,4.22-5.577,6.094c-0.958,1.874-1.138,7.091-1.138,7.091l-4.52,5.844l-1.106,0.837L73.568,156.85z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 0.4147,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 62.55,
    y1: 209.825,
    x2: 60.446,
    y2: 236.858
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 0.4147,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 123.658,
    y1: 212.035,
    x2: 125.271,
    y2: 241.862
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.4147,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M31.289,169.464c-0.836,0.665-5.16,4.242-5.86,10.561c-0.762,6.884,3.378,11.596,4.025,12.308"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.4147,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M134.015,231.162c1.112,1.235,5.436,5.742,12.702,6.724c6.891,0.932,12.032-1.9,13.514-2.788"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M322.939,254.845l9.275-4.958l13.758,2.522l6.879-7.338l16.28,4.357l9.058-12.382l16.174,9.914 l-5.503-34.963l-21.342-14.943l-49.052,7.72c-1.837,0.289-3.091,2.012-2.802,3.849L322.939,254.845z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6D6D6"
    },
    d: "M372.503,214.571l16.357-2.574l-21.342-14.943l2.469,15.685 C370.175,213.94,371.302,214.76,372.503,214.571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 0.274,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M367.518,197.053l2.469,15.685c0.189,1.201,1.316,2.021,2.517,1.832l16.357-2.574"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M329.551,300.752c0.289,1.837,2.012,3.091,3.849,2.802l64.257-10.113 c1.837-0.289,3.091-2.012,2.802-3.849l-6.096-38.734l-16.174-9.914l-9.058,12.382l-16.28-4.357l-6.879,7.338l-13.758-2.522 l-9.275,4.958L329.551,300.752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 0.274,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M322.952,254.845l9.275-4.958l13.758,2.522l6.879-7.338l16.28,4.357l9.058-12.382l16.174,9.914l-5.503-34.963l-21.342-14.943 l-49.052,7.72c-1.837,0.289-3.091,2.012-2.802,3.849L322.952,254.845z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 0.274,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M329.564,300.752c0.289,1.837,2.012,3.091,3.849,2.802l64.257-10.113c1.837-0.289,3.091-2.012,2.802-3.849l-6.096-38.734 l-16.174-9.914l-9.058,12.382l-16.28-4.357l-6.879,7.338l-13.758-2.522l-9.275,4.958L329.564,300.752z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF7129"
    },
    points: "74.361,146.097 72.739,147.645 58.391,134.69 62.521,130.751  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF7129"
    },
    points: "77.906,143.441 75.701,143.849 70.78,125.155 76.392,124.118  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF7129"
    },
    points: "70.26,149.623 70.076,151.858 50.745,151.712 51.214,146.024  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7129"
    },
    d: "M301.209,433.06L301.209,433.06c-4.85-4.767-4.918-12.563-0.151-17.413l56.693-57.687 l17.564,17.262l-56.693,57.686C313.855,437.759,306.059,437.827,301.209,433.06z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -0.0023 0.0023 1 -0.7479 0.913)",
    style: {
      opacity: 0.2,
      fill: "#DCF0FF"
    },
    cx: 402.241,
    cy: 330.258,
    rx: 49.79,
    ry: 49.79
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M355.646,347.806c1.679,4.467,4.019,8.739,7.024,12.664l89.35-30.905 c-0.067-4.831-0.836-9.651-2.299-14.299L355.646,347.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M352.569,333.549c0.186,2.825,0.613,5.635,1.279,8.4l93.673-32.4 c-1.168-2.555-2.559-5.03-4.181-7.396L352.569,333.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7129"
    },
    d: "M442.518,289.275c-22.634-22.245-59.016-21.929-81.261,0.706 c-22.245,22.634-21.929,59.016,0.706,81.261c22.634,22.245,59.016,21.929,81.261-0.706 C465.469,347.901,465.153,311.519,442.518,289.275z M369.071,364.009c-18.64-18.319-18.9-48.28-0.581-66.921 c18.319-18.64,48.28-18.9,66.92-0.581c18.64,18.319,18.9,48.28,0.581,66.921C417.673,382.068,387.711,382.328,369.071,364.009z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 361.731,
    y1: 380.529,
    x2: 316.903,
    y2: 426.142
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M406.361,276.925 c-14.124-1.425-28.767,3.45-39.219,13.056c-10.452,9.607-16.541,23.788-16.309,37.982"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/NotFound.9af5828e24861d7cea42884654bf59ac.svg";
export { ForwardRef as ReactComponent };